/**
 * <petters-tabs> — sélecteur produit : une liste cliquable d'un côté,
 * le produit affiché de l'autre.
 *
 * Implémente le motif ARIA « tabs » : flèches pour naviguer, Début/Fin pour
 * aller aux extrémités, et un seul onglet dans l'ordre de tabulation.
 */
class PettersTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[data-tab]')];
    this.panels = [...this.querySelectorAll('[data-panel]')];
    if (this.tabs.length === 0) return;

    this.index = 0;

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.select(i));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, i));
      // Le survol prépare l'image : le changement paraît instantané au clic.
      tab.addEventListener('mouseenter', () => this.preload(i));
    });

    this.select(0, false);
  }

  onKeydown(event, i) {
    const last = this.tabs.length - 1;
    let next = null;

    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowRight':
        next = i === last ? 0 : i + 1;
        break;
      case 'ArrowUp':
      case 'ArrowLeft':
        next = i === 0 ? last : i - 1;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = last;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.select(next);
    this.tabs[next].focus();
  }

  preload(i) {
    const img = this.panels[i]?.querySelector('img[loading="lazy"]');
    if (img) img.loading = 'eager';
  }

  select(i, moveFocus = true) {
    this.index = i;

    this.tabs.forEach((tab, index) => {
      const active = index === i;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      // Un seul onglet reste tabulable : on entre dans la liste avec Tab,
      // puis on circule aux flèches.
      tab.tabIndex = active ? 0 : -1;

      // La ligne entière porte l'état : c'est elle qui déplie le détail et
      // affiche le repère vertical, pas seulement son bouton d'en-tête.
      tab.closest('.pt-bs__row')?.classList.toggle('is-active', active);
    });

    this.panels.forEach((panel, index) => {
      const active = index === i;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });

    if (moveFocus) this.preload(i);
  }
}

if (!customElements.get('petters-tabs')) {
  customElements.define('petters-tabs', PettersTabs);
}
